function getRouter(tab) {
  // 目前采用一个表单一个tab并使用keep-alive，所以不需要使用全路由跳转
  // if (Object.keys(tab.query).length > 0) return {path: tab.path, query: tab.query}
  // if (Object.keys(tab.params).length > 0) return {name: tab.routerName, params: tab.params}
  return tab.path
}

const state = {
  token: '',
  activeTabIndex: 0,
  username: '',
  toggleMenu: false,
  permissions: 'editor',
  headerTabs: [
    {
      name: '首页',
      meta: {
        tabAttr: 'constant',
        value: 'dashboard'
      },
      routerName: '首页',
      params: {},
      path: '/dashboard',
      query: {},
      item_key: 'dashboard'
    }
  ],
  loading: false,
  keepInclude: [],
  keepExclude: [],
  roCopyInfo: {},
  isNewTab: {
    index: '',
    falge: false
  },
  dashboard_bg: {
    img_url: 'dashboard_bg01.png',
    img_name: '背景一'
  },
  mq_msg: {},
  mq_status: 0,
  messageNum: 0,
  openItem: {
    test: 1
  },
  form_id_status: false
}
if (localStorage['show_form_id'] === 'true') {
  state.form_id_status = true
}
const mutations = {
  set_messageNum(state, num) {
    state.messageNum = Number(num)
  },
  set_mq_msg(state, msg) {
    state.mq_status += 1
    state.mq_msg = {
      mq_msg: msg,
      mq_status: state.mq_status
    }
  },
  set_open_item(state, item) {
    state.openItem = item
    // console.log(state.openItem)
  },
  set_dashboard_bg(state, img) {
    // console.log(img)
    state.dashboard_bg = img
  },
  set_FormId_status(state, data) {
    // console.log(data)
    state.form_id_status = data.show_form_id
  },
  // =============
  // 需求订单挂组件复制
  addCopyInfoForRo(state, data) {
    state.roCopyInfo = data
  },
  // 点击tab选项卡删除键方法
  deleteHeaderTab(state, data = { that: {}, index: '' }) {
    const that = data.that
    const index = parseInt(data.index)
    const activeTab = state.headerTabs[state.activeTabIndex]
    const nextTab = state.headerTabs[index + 1] || state.headerTabs[index - 1]
    const deleteTab = state.headerTabs[index]
    this.commit('changeKeepExclude', deleteTab.meta.value)
    if (state.isNewTab.index === index) {
      state.isNewTab.flage = false
    }
    state.headerTabs.splice(index, 1)
    if (nextTab) {
      // 为什么要判断一下呢？
      // 如果当前路由（activeTab）就是下个目标路由（nextTab）
      // 直接跳转（that.$router.push(nextTab.link)）vue-router会判断路由一样就不会跳转（就不执行 pushHeaderTab函数）
      if (activeTab.meta.value === nextTab.meta.value) {
        state.headerTabs.forEach((item, key) => {
          if (nextTab.meta.value === item.meta.value) {
            state.activeTabIndex = key
          }
        })
      } else {
        that.$router.push(getRouter(nextTab))
      }
    }
  },
  changeActiveTabIndex(state, data = { that: {}, index: '' }) {
    const that = data.that
    const index = data.index
    if (state.activeTabIndex === parseInt(index)) return false
    const nextTab = state.headerTabs[index]
    if (nextTab) {
      that.$router.push(getRouter(nextTab))
    }
  },
  toggleMenu(state, flag) {
    state.toggleMenu = flag
  },
  loadingChange(state, val) {
    state.loading = val
  },
  changeKeepInclude(state, item) {
    if (state.keepInclude.indexOf(item) === -1) {
      state.keepInclude.push(item)
    }
  },
  changeKeepExclude(state, item) {
    const index = state.keepInclude.indexOf(item)
    if (index === -1) return
    state.keepInclude.splice(index, 1)
  }
}
const getters = {
  activeTabIndex: state => state.activeTabIndex,
  headerTabs: state => state.headerTabs,
  toggleMenu: state => state.toggleMenu,
  keepInclude: state => state.keepInclude,
  keepExclude: state => state.keepExclude,
  copyData: state => state.roCopyInfo,
  getisNewTab: state => state.isNewTab,
  set_dashboard_bg: state => state.set_dashboard_bg,
  set_mq_msg: state => state.set_mq_msg,
  set_open_item: state => state.set_open_item,
  set_FormId_status: state => state.set_FormId_status,
  set_messageNum: state => state.set_messageNum
}
const globalStore = {
  state,
  getters,
  mutations
}
export default globalStore



// WEBPACK FOOTER //
// ./src/store/modules/global.js